module.exports = __webpack_public_path__ + "static/media/attachment-active.03650f8c.svg";